import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout, { PageHero } from '../../components/PublicLayout';
import { Wallet, Sparkles, Users, GraduationCap, ArrowRight, Check } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useLanguage } from '../../lib/LanguageContext';

const offers = [
  { id: 'courant', icon: Wallet, name: 'Compte courant', tagline: 'Sans frais cachés', desc: 'Le compte essentiel pour votre quotidien : virements SEPA illimités, IBAN français, application mobile complète.',
    bullets: ['Aucun frais d’ouverture', 'Virements SEPA gratuits', 'Carte Visa Basic incluse', 'Support 24/7'] },
  { id: 'livret', icon: Sparkles, name: 'Livret épargne BFI', tagline: 'Taux progressif jusqu’à 3,5%', desc: 'Faites fructifier votre épargne en toute sécurité, retraits possibles à tout moment, capital garanti.',
    bullets: ['Capital garanti', 'Retraits libres', 'Versements automatiques', 'Plafond 100 000 €'] },
  { id: 'joint', icon: Users, name: 'Compte joint', tagline: 'Pour 2 ou plus', desc: 'Partagez la gestion des dépenses du foyer simplement, avec une ou plusieurs cartes associées.',
    bullets: ['2 cartes incluses', 'Partage en temps réel', 'Notifications instantanées', 'IBAN dédié'] },
  { id: 'jeune', icon: GraduationCap, name: 'Compte Jeune (12-25 ans)', tagline: 'Gratuit, pédagogique', desc: 'Le 1er compte des jeunes, avec contrôle parental, plafonds adaptés et conseils financiers.',
    bullets: ['Carte Visa Electron', 'Contrôle parental', 'Plafonds personnalisés', 'Coaching budget'] },
];

export default function Comptes() {
  const { t } = useLanguage();
  return (
    <PublicLayout>
      <PageHero eyebrow={t('public.comptesEyebrow')} title={t('public.comptesTitle')} subtitle={t('public.comptesSubtitle')}>
        <Link to="/inscription"><Button size="lg" className="bg-white text-blue-900 hover:bg-slate-100">{t('public.openAccount')} <ArrowRight className="ml-2 w-4 h-4"/></Button></Link>
      </PageHero>
      <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-6">
        {offers.map((o) => (
          <div key={o.id} id={o.id} className="p-6 md:p-8 rounded-2xl border border-slate-200 bg-white hover:shadow-lg transition">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-700 flex items-center justify-center"><o.icon className="w-6 h-6"/></div>
              <div>
                <div className="text-xs text-blue-700 font-semibold uppercase">{o.tagline}</div>
                <h2 className="font-bold text-xl text-slate-900">{o.name}</h2>
              </div>
            </div>
            <p className="text-slate-600 mt-3">{o.desc}</p>
            <ul className="mt-4 space-y-2 text-sm">
              {o.bullets.map((b, i) => <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> {b}</li>)}
            </ul>
            <div className="mt-6"><Link to="/inscription"><Button variant="outline">{t('public.discover')} <ArrowRight className="ml-1 w-4 h-4"/></Button></Link></div>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
